var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgArrowDownOutline = function SvgArrowDownOutline(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "arrow-down-outline_svg__ionicon",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 48,
    d: "m112 268 144 144 144-144M256 392V100"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDownOutline);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;